import React from "react";

export interface MetricsBarData {
    label: string;
    value: number;
    color?: string;
    testId?: string;
    onClick?: () => void;
}

interface MetricsBarsProps {
    label: string;
    bars: MetricsBarData[];
}

export const metricsColors = ["#cc3a52", "#ffd654", "#008559"]

const formatValue = (value: number): string =>
    value < 10 ? `0${value}` : `${value}`;

const MetricsBars: React.FC<MetricsBarsProps> = ({ label, bars }) => {
    const allZero = bars.every((b) => b.value === 0);
    const maxValue = Math.max(...bars.map((b) => b.value), 1);

    return (
        <div className={`metrics-bars${allZero ? " metrics-bars--empty" : ""}`}>
            <div className="metrics-bars__label">{label}</div>
            <div className="metrics-bars__chart">
                {allZero
                    ? bars.map((_bar, index) => (
                        <div key={index} className="metrics-bars__column">
                            <div className="metrics-bars__bar-wrapper">
                                <div
                                    className="metrics-bars__bar metrics-bars__bar-empty"
                                    style={{
                                        height: "50%",
                                    }}
                                />
                            </div>
                            <span className="metrics-bars__value">&nbsp;</span>
                            <span className="metrics-bars__bar-label">&nbsp;</span>
                        </div>
                    ))
                    : bars.filter(bar => bar.value > 0).map((bar, index) => (
                        <div
                            key={index}
                            className={`metrics-bars__column${bar.onClick ? " metrics-bars__column--clickable" : ""}`}
                            onClick={bar.onClick}
                            data-testid={bar.testId}
                        >
                            <div className="metrics-bars__bar-wrapper">
                                <div
                                    className="metrics-bars__bar"
                                    style={{
                                        backgroundColor: bar.color ?? metricsColors[index % metricsColors.length],
                                        height: `${(bar.value / maxValue) * 100}%`,
                                    }}
                                />
                            </div>
                            <span className="metrics-bars__value">
                                {formatValue(bar.value)}
                            </span>
                            <span className="metrics-bars__bar-label">
                                {bar.label}
                            </span>
                        </div>
                    ))}
            </div>
        </div>
    );
};

export default MetricsBars;

